import React, { useEffect, useState } from 'react';
import { Button, Popconfirm, Tag } from 'antd';
import { useHistory } from 'react-router-dom';
import { Training } from './Training';
import { Model, Algorithm, Training as TrainingType } from '../../../types';
import CreateVersion from './CreateVersion';
import CreateClassificationVersion from './CreateClassificationVersion';
import { isDocumentClassification } from '../../../lib/util';
import { getSecondToLatestDatasetVersion } from '../../../lib/api/dataset-api';
import { createTraining, startTraining } from '../../../lib/api/training-api';

type Props = {
  trainingList: TrainingType[];
  onItemClickUrl: (trainingId: string) => any;
  model: Model;
  algorithm: Algorithm;
};

const VersionHistory = (props: Props) => {
  let history = useHistory();

  const { trainingList, onItemClickUrl, model, algorithm } = props;

  const [newVersionVisible, setNewVersionVisible] = useState(false);
  const [retrainPopup, setRetrainPopup] = useState(false);

  const [datasetVersionName, setDatasetVersionName] = useState('');

  const sortedTrainingList = [...trainingList].sort(
    (a, b) => new Date(b.timeCreated).getTime() - new Date(a.timeCreated).getTime()
  );
  const latestTraining = sortedTrainingList[0];
  const latestTrainingName = latestTraining ? latestTraining.modelVersionName : null;

  useEffect(() => {
    const fetchDatasetVersion = async () => {
      try {
        if (props.model.datasetId) {
          const datasetVersion = await getSecondToLatestDatasetVersion(props.model.datasetId.toString());
          setDatasetVersionName(datasetVersion.version_id);
        }
      } catch (error) {
        console.error('Error fetching dataset version:', error);
      }
    };

    fetchDatasetVersion();
  }, [props.model.datasetId]);

  const toggleNewVersion = () => {
    setNewVersionVisible(!newVersionVisible);
  };

  const toggleRetrainPopup = () => {
    setRetrainPopup(!retrainPopup);
  };

  const retrain = async () => {
    if (!props.model.datasetId) return;

    const datasetVersion = await getSecondToLatestDatasetVersion(props.model.datasetId.toString());
    const training = await createTraining(model.id, [], datasetVersion.version_id);
    await startTraining(training.id);
    history.push(`/custom/${model.algorithm.id}/model/${model.id}`);
    window.location.reload();
  };

  const onCreate = (training: TrainingType) => {
    history.push(`/custom/${training.id}/result?readOnly=false`);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {model.datasetId !== null && isDocumentClassification(algorithm) ? (
        <CreateClassificationVersion
          visible={newVersionVisible}
          onClose={toggleNewVersion}
          model={model}
          version={trainingList && trainingList.length > 0 ? trainingList[0] : null}
          onCreate={onCreate}
        />
      ) : (
        <CreateVersion
          visible={newVersionVisible}
          onClose={toggleNewVersion}
          model={model}
          version={trainingList && trainingList.length > 0 ? trainingList[0] : null}
          onCreate={onCreate}
        />
      )}
      <div>
        <span
          style={{
            float: 'left',
            fontWeight: 700,
            fontSize: '20px',
            color: '#005FA5',
          }}>
          Version history
        </span>
        <span style={{ float: 'right' }}>
          {props.model.datasetId && latestTrainingName !== datasetVersionName && (
            <Tag color="orange" style={{ fontSize: 14, marginRight: '10px', marginTop: '3px' }}>
              Newer Dataset version available
            </Tag>
          )}

          <span style={{ float: 'right' }}>
            {model.datasetId ? (
              <Popconfirm
                title="Retrain with latest committed Dataset version?"
                visible={retrainPopup}
                onConfirm={() => {
                  retrain();
                  toggleRetrainPopup();
                }}
                onCancel={toggleRetrainPopup}
                okText="Yes"
                cancelText="No">
                <Button type="primary" onClick={toggleRetrainPopup}>
                  Retrain
                </Button>
              </Popconfirm>
            ) : (
              <Button type="primary" onClick={toggleNewVersion}>
                New Version
              </Button>
            )}
          </span>
        </span>
      </div>
      <div style={{ marginTop: '30px' }}>
        {trainingList.length > 0 ? (
          trainingList.map((training, index) => (
            <Training
              isOpen={index === 0}
              index={index}
              key={index}
              training={training}
              model={model}
              onItemClickUrl={onItemClickUrl}
            />
          ))
        ) : (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <span style={{ color: '#7E7F87', fontSize: '16px' }}>No versions yet</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default VersionHistory;
